module.exports = __webpack_public_path__ + "media/adidas.e782285e.mp4";